import { render, staticRenderFns } from "./SCSAward.vue?vue&type=template&id=6a674f08&"
import script from "./SCSAward.vue?vue&type=script&lang=js&"
export * from "./SCSAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports